/*
* @描述: 订单代采新增
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/15 10:27
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div v-loading="loading" class="detail_wrap_container">
                <div class="m_page_little_title">
                    <span class="title">基本信息</span>
                </div>
                <van-form ref="purchaseForm"
                          error-message-align="right"
                          input-align="right"
                          label-width="10em"
                          scroll-to-error>
                    <div class="detail_chunk_wrap">
                        <ul class="purchase_table_list">
                            <li v-for="(item,index) in purchaseForm.purchase_details" class="purchase_details_item">
                                <div class="purchase_details_item_index">
                                    <span v-text="'代采' + (index+1)"></span>
                                    <span v-if="purchaseForm.purchase_details.length>1"
                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                          @click="handleClickDelPurchaseDetails(index)">
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                </div>
                                <div class="purchase_details_item_content">
                                    <van-form input-align="right"
                                              label-width="12em"
                                              size="small">
                                        <van-field v-if="isFieldShowHide('supplier')"
                                                   label="供应商（个人或公司名称）"
                                                   v-model="item.supplier"
                                                   :disabled="isFieldDisabled('supplier')"
                                                   name="supplier"
                                                   maxlength="521"
                                                   placeholder="请输入供应商名称">
                                        </van-field>
                                        <ul class="goods_details_list">
                                            <li v-for="(goods,goods_index) in item.goods_details"
                                                class="goods_details_item">
                                                <div class="goods_details_index">
                                                    <span v-text="'产品明细' + (goods_index+1)"></span>
                                                    <span v-if="item.goods_details.length>1"
                                                          class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="item.goods_details.splice(goods_index,1)">
                                                                <i class="el-icon-remove"></i>
                                                            </span>
                                                </div>
                                                <div class="goods_details_content">
                                                    <van-form :ref="'goods_details_form_' + index + '_' + goods_index"
                                                              error-message-align="right"
                                                              input-align="right"
                                                              label-width="4em">
                                                        <van-field v-if="isFieldShowHide('goods_name')"
                                                                   :disabled="isFieldDisabled('goods_name')"
                                                                   label="产品名称"
                                                                   v-model="goods.goods_name"
                                                                   :rules="purchaseFormRules.goods_name"
                                                                   name="goods_name"
                                                                   placeholder="请输入产品名称"
                                                                   required>
                                                        </van-field>
                                                        <van-field v-if="isFieldShowHide('price')"
                                                                   label="单价"
                                                                   v-model="goods.price"
                                                                   :disabled="isFieldDisabled('price')"
                                                                   name="price"
                                                                   placeholder="请输入单价"
                                                                   @blur="handleGoodsPriceBlur(goods,item)">
                                                        </van-field>
                                                        <van-field v-if="isFieldShowHide('num')"
                                                                   :disabled="isFieldDisabled('num')"
                                                                   label="数量"
                                                                   v-model="goods.num"
                                                                   :rules="purchaseFormRules.num"
                                                                   name="num"
                                                                   required
                                                                   placeholder="请输入单价"
                                                                   @blur="handleGoodsNumBlur(goods,item)">
                                                        </van-field>
                                                        <van-field v-model="goods.subtotal_price"
                                                                   name="subtotal_price"
                                                                   label="产品总价"
                                                                   placeholder="自动算出"
                                                                   readonly>
                                                        </van-field>
                                                    </van-form>
                                                </div>
                                            </li>
                                        </ul>
                                        <div v-if="!approval_id"
                                             class="add_purchase_details_btn"
                                             @click="handleClickAddPurchaseDetails(item)">
                                            <i class="el-icon-plus"></i>
                                            <span>添加产品</span>
                                        </div>
                                    </van-form>
                                </div>
                            </li>
                        </ul>
                        <div v-if="!approval_id" class="add_purchase_btn" @click="handleClickAddPurchaseList">
                            <i class="el-icon-plus"></i>
                            <span>添加代采</span>
                        </div>
                    </div>
                    <van-field v-model="purchaseForm.total_price"
                               disabled
                               label="代采产品总金额"
                               name="total_price"
                               placeholder="自动算出">
                    </van-field>
                    <van-field v-if="isFieldShowHide('discount_price')"
                               v-model="purchaseForm.discount_price"
                               :disabled="isFieldDisabled('discount_price')"
                               label="总优惠金额"
                               name="discount_price"
                               placeholder="请输入总优惠金额"
                               @blur="handleDiscountPriceBlur">
                    </van-field>
                    <van-field v-model="purchaseForm.actual_total_price"
                               disabled
                               label="实际代采总金额"
                               name="actual_total_price"
                               placeholder="自动算出">
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field v-if="isFieldShowHide('remarks')"
                                   v-model="purchaseForm.remark"
                                   :disabled="isFieldDisabled('remarks')"
                                   autosize
                                   label="备注"
                                   name="remark"
                                   placeholder="请输入备注"
                                   maxlength="255"
                                   type="textarea">
                        </van-field>
                    </div>
                    <div class="vertical_input_wrap">
                        <van-field label="附件"
                                   name="file"
                                   readonly>
                            <template #input>
                                <div class="m_file_outer_wrap">
                                    <p v-if="purchaseForm.file.length === 0" class="file_type_hint">
                                        支持Word、Excel、PDF等常见类型</p>
                                    <ul v-else class="m_upload_file_list">
                                        <li v-for="(file,file_idx) in purchaseForm.file"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="删除"
                                                            effect="dark"
                                                            placement="top">
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="purchaseForm.file.splice(file_idx,1)">
                                                        <i class="iconfont icon-shanchu1"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="m_upload_file_btn">
                                        <input class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleUploadFileChange($event)">
                                        <el-link :underline="false" type="primary">
                                            <i class="iconfont icon-shangchuan"></i>上传附件
                                        </el-link>
                                    </div>
                                </div>
                            </template>
                        </van-field>
                    </div>
                </van-form>
                <div v-if="purchaseForm.order_price_change.length">
                    <div class="m_page_little_title">
                        <span class="title">订单金额变更信息</span>
                    </div>
                    <div class="hint pl_24 mb_8"> 审批通过后（无需审批请忽略），以下订单金额将变更</div>
                    <div class="detail_chunk_wrap">
                        <ul class="order_price_change_list">
                            <li v-for="item in purchaseForm.order_price_change"
                                class="order_price_change_item flex_wrap">
                                <div class="field_name" v-text="item.field_name+'：'"></div>
                                <div>
                                    <span class="value_text"
                                          v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                                    <i class="iconfont icon-youjiantou"></i>
                                    <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="isApproval===1 && !approval_id" class="add_approval_select_process">
                    <div class="m_page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <div class="detail_chunk_wrap">
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="purchaseForm.node_list">
                        </approveProcessSelect>
                    </div>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button size="large"
                            type="primary"
                            @click="handleClickAddPurchaseConfirm">提交
                </van-button>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </div>
    </van-popup>
</template>
<script>
import {
    getApprovalNodes,
    getFormFields,
    orderDetail,
    purchaseAdd,
    getApprovalFormInfo,
    editApprovalFormInfo,
    purchaseDetails,
} from "@/api";
import {calculate, formatFileSize, getBusinessIsApproval, isFieldShowHide, isFieldDisabled} from "@/utils";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";

export default {
    name: "orderPurchaseAdd",
    data() {
        return {
            loading: false,
            purchaseList: [],
            editPurchaseDialog: false,
            purchaseForm: {
                total_price: '',
                actual_total_price: '',
                discount_price: '',
                remarks: '',
                file: [],
                purchase_details: [
                    {
                        supplier: '',
                        goods_details: [
                            {
                                goods_name: '',
                                price: '',
                                num: undefined,
                                subtotal_price: ''
                            }
                        ],
                        total_amount: ''
                    }
                ],
                order_price_change: [],
                node_list: []
            },
            purchaseFormRules: {
                goods_name: [{required: true, message: '请输入产品名称', trigger: 'blur'}],
                num: [{required: true, message: '请输入数量', trigger: 'blur'}],
            },
            isApproval: 0,
            purchasePrice: 0,
            purchase_total_amount: 0,
            btnDisabled: false,
            cancel_reason: '',
            invalidatePurchaseDialog: false,
            previewImgList: [],
            previewImgSrc: '',
            order_detail: {},
            order_amount_field: [],
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [Number, String],
            default: 0
        },
        approval_id: {
            type: [Number, String],
            default: 0
        },
        field_auth: {
            type: [Array, Object],
            default: () => []
        },
        order_purchase_id: {
            type: [Number, String],
            default: 0
        },
    },
    components: {ReturnNavBar, approveProcessSelect},
    created() {
        // 审批修改
        if (this.approval_id) {
            this.getApprovalFormInfoDetail()
        }
        this.getOrderDetail()
    },
    computed: {},
    mounted() {
    },
    methods: {
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        // 审批编辑时获取详情
        getApprovalFormInfoDetail() {
            this.loading = true
            getApprovalFormInfo({
                approval_id: this.approval_id
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseForm.total_price = res.data.total_price
                    this.purchaseForm.actual_total_price = res.data.actual_total_price
                    this.purchaseForm.discount_price = res.data.discount_price
                    this.purchaseForm.remarks = res.data.remarks
                    this.purchaseForm.file = res.data.file
                    this.purchaseForm.purchase_details = res.data.purchase_details
                    this.purchaseForm.order_price_change = res.data.order_price_change
                }
                this.loading = false
            })
        },

        // 是否显示隐藏
        isFieldShowHide(field_key) {
            return isFieldShowHide(this.field_auth, field_key)
        },

        // 是否只读
        isFieldDisabled(field_key) {
            return isFieldDisabled(this.field_auth, field_key)
        },

        //获取订单详情
        getOrderDetail() {
            this.loading = true
            orderDetail({
                order_id: this.order_id,
            }).then(res => {
                if (res.code === 200) {
                    this.order_detail = res.data
                    getFormFields({
                        field_form: 'orders'
                    }).then(res => {
                        if (res.code === 200) {
                            this.order_amount_field = res.data.find(item => item.field_key === 'amount_information')._child || []
                            if (this.order_purchase_id) {
                                purchaseDetails({
                                    order_purchase_id: this.order_purchase_id
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.purchaseForm.total_price = res.data.total_price
                                        this.purchaseForm.actual_total_price = res.data.actual_total_price
                                        this.purchaseForm.discount_price = res.data.discount_price
                                        this.purchaseForm.remarks = res.data.remarks
                                        this.purchaseForm.file = res.data.file
                                        this.purchaseForm.purchase_details = res.data.purchase_details
                                        this.computedOrderAmountInfo('purchase_price')
                                        this.orderPurchaseAddVisible = true
                                    } else {
                                        this.$message.error(res.message)
                                    }
                                })
                            }
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                    this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price)
                    getBusinessIsApproval('order_purchase').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'order_purchase',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.purchaseForm.node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                }
            })
        },

        //点击新增代采列表
        handleClickAddPurchaseList() {
            this.purchaseForm.purchase_details.push({
                supplier: '',
                goods_details: [
                    {
                        goods_name: '',
                        price: '',
                        num: '',
                        subtotal_price: ''
                    }
                ],
                total_amount: ''
            })
        },

        //添加明细
        handleClickAddPurchaseDetails(item) {
            item.goods_details.push({
                goods_name: '',
                price: '',
                num: undefined,
                subtotal_price: ''
            })
        },

        //单价输入框失焦事件
        handleGoodsPriceBlur(goods, purchase) {
            let val = goods.price.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            goods.price = amount.toFixed(2);
            if (goods.price && goods.num) {
                goods.subtotal_price = (goods.price * goods.num).toFixed(2)
            } else {
                goods.subtotal_price = 0
            }
            purchase.total_amount = purchase.goods_details.reduce((sum, obj) => {
                const amount = obj.subtotal_price ? parseFloat(obj.subtotal_price) : 0;
                return sum + amount;
            }, 0)
            this.computedPurchaseTotalPrice()
        },

        //数量输入框失焦事件
        handleGoodsNumBlur(goods, purchase) {
            goods.num = goods.num ? goods.num : 0
            goods.num = Number(goods.num).toFixed(0)
            if (goods.price && goods.num) {
                goods.subtotal_price = (goods.price * goods.num).toFixed(2)
            } else {
                goods.subtotal_price = 0
            }
            purchase.total_amount = purchase.goods_details.reduce((sum, obj) => {
                const amount = obj.subtotal_price ? parseFloat(obj.subtotal_price) : 0;
                return sum + amount;
            }, 0)
            this.computedPurchaseTotalPrice()
        },

        //点击删除代采明细
        handleClickDelPurchaseDetails(index) {
            this.purchaseForm.purchase_details.splice(index, 1)
        },

        //计算代采总金额
        computedPurchaseTotalPrice() {
            const total = this.purchaseForm.purchase_details.reduce((sum, obj) => {
                const amount = obj.total_amount ? parseFloat(obj.total_amount) : 0;
                return sum + amount;
            }, 0);
            this.purchaseForm.total_price = total.toFixed(2)
            //计算实际代采总金额 = 总优惠金额?订单总金额 - 总优惠金额: 订单总金额
            this.purchaseForm.actual_total_price = this.purchaseForm.discount_price ? (this.purchaseForm.total_price - this.purchaseForm.discount_price).toFixed(2) : this.purchaseForm.total_price
            this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - (this.purchase_total_amount - (this.purchaseForm.total_price ? parseFloat(this.purchaseForm.total_price) : 0))
            if (this.purchasePrice !== parseFloat(this.order_detail.purchase_cost_price)) {
                this.computedOrderAmountInfo('purchase_price')
            } else {
                this.purchaseForm.order_price_change = []
            }
        },

        //总优惠金额输入框失焦，计算实际代采总金额
        handleDiscountPriceBlur() {
            let val = this.purchaseForm.discount_price.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            if (amount > Number(this.purchaseForm.total_price)) {
                this.purchaseForm.discount_price = ''
                return this.$toast.fail('总优惠金额不能大于代采物品总金额')
            }
            this.purchaseForm.discount_price = amount.toFixed(2);
            if (this.purchaseForm.discount_price && this.purchaseForm.total_price) {
                this.purchaseForm.actual_total_price = (this.purchaseForm.total_price - this.purchaseForm.discount_price).toFixed(2)
                this.purchasePrice = parseFloat(this.order_detail.purchase_cost_price) - (this.purchase_total_amount - (this.purchaseForm.actual_total_price ? parseFloat(this.purchaseForm.actual_total_price) : 0))
                if (this.purchasePrice !== parseFloat(this.order_detail.purchase_cost_price)) {
                    this.computedOrderAmountInfo('purchase_price')
                } else {
                    this.purchaseForm.order_price_change = []
                }
            }
        },

        //订单金额信息计算
        computedOrderAmountInfo(field_key) {
            this.order_amount_field.forEach(field => {
                if (field.extend.field_formula.includes(field_key)) {
                    const components = field.extend.formula_list.filter(formula => formula.type === 'component' || formula.type === 'product_cost' || formula.type === 'product_total_price' || formula.type === 'purchase_price')
                    if (components.length > 0) {
                        //接口需要的数据
                        const formulaValue = {}
                        components.forEach(component => {
                            if (component.type === 'component') {
                                if (component.field_type === 'order_amount_compute_mode') {
                                    formulaValue[component.field_key] = this.order_detail[component.field_key].value
                                } else if (component.field_type === 'money_compute_mode') {
                                    formulaValue[component.field_key] = this.order_detail[component.field_key].value
                                }
                            } else if (component.type === 'product_cost' || component.type === 'product_total_price') {
                                let filteredGoods = []
                                if (component.commodity_value_config.length === 0) {
                                    filteredGoods = this.order_detail.order_goods;
                                } else {
                                    component.commodity_value_config.forEach(config => {
                                        if (config.type === 'category') {
                                            this.order_detail.order_goods.forEach(good => {
                                                if (good.category_id === config.id) {
                                                    filteredGoods.push(good)
                                                }
                                            })
                                        } else if (config.type === 'goods') {
                                            this.order_detail.order_goods.forEach(good => {
                                                if (good.goods_id === config.id) {
                                                    filteredGoods.push(good)
                                                }
                                            })
                                        }
                                    })
                                }
                                if (field.extend.applicable_products !== 'all') {
                                    const typeMap = {sale: 1, lease: 2};
                                    const productType = typeMap[field.extend.applicable_products];
                                    filteredGoods = filteredGoods.filter(item => item.type === productType);
                                }
                                const sumFunc = (sum, item) => sum + (component.type === 'product_cost' ? parseFloat(item.cost_price) * item.num : Number(item.subtotal_price.value));
                                formulaValue[component.field_key] = filteredGoods.reduce(sumFunc, 0);
                            } else if (component.type === 'purchase_price') {
                                formulaValue[component.field_key] = this.purchasePrice
                            }
                        })
                        if (Object.values(formulaValue).length > 0) {
                            let res = calculate(field.extend.field_formula, formulaValue)
                            const amount_change = this.purchaseForm.order_price_change.find(item => item.field_key === field.field_key)
                            if (amount_change) {
                                if (field.extend.num_display_style === '1') {
                                    amount_change.new_value = {
                                        value: Number(res.toFixed(2)),
                                        text: Number(res.toFixed(2)).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }),
                                        value_converted: Number(res.toFixed(2)),
                                        currency: "CNY",
                                    }
                                } else {
                                    amount_change.new_value = {
                                        value: Number(res.toFixed(4)),
                                        text: (Math.floor(Number(res.toFixed(4)) * 10000) / 100).toFixed(2),
                                        value_converted: Number(res.toFixed(4)),
                                        currency: "CNY",
                                    }
                                }
                            } else {
                                const price_change = {
                                    field_name: field.field_name,
                                    field_key: field.field_key,
                                    old_value: this.order_detail[field.field_key] ? this.order_detail[field.field_key] : {},
                                    new_value: {
                                        value: 0,
                                        text: "",
                                        value_converted: "",
                                        currency: "CNY",
                                    },
                                }
                                if (field.extend.num_display_style === '1') {
                                    price_change.new_value.value = Number(res.toFixed(2))
                                    price_change.new_value.text = price_change.new_value.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    price_change.new_value.value_converted = Number(res.toFixed(2))
                                } else {
                                    price_change.new_value.value = Number(res.toFixed(4))
                                    price_change.new_value.text = (Math.floor(price_change.new_value.value * 10000) / 100).toFixed(2)
                                    price_change.new_value.value_converted = Number(res.toFixed(4))
                                }
                                this.purchaseForm.order_price_change.push(price_change)
                            }
                        }
                    }
                }
            })
        },

        deepFormValidate(name) {
            const that = this
            return new Promise(function (resolve, reject) {
                if (Array.isArray(that.$refs[name])) {
                    that.$refs[name][0].validate().then(() => {
                        resolve();
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    that.$refs[name].validate().then(() => {
                        resolve();
                    }).catch(error => {
                        reject(error)
                    })
                }
            })
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$toast.fail('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.purchaseForm.file.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$toast.fail('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //新增代采确定事件
        handleClickAddPurchaseConfirm() {
            let newArr = [];
            this.purchaseForm.purchase_details.forEach((item, index) => {
                item.goods_details.forEach((goods, goods_index) => {
                    let res = this.deepFormValidate(`goods_details_form_${index}_${goods_index}`)
                    newArr.push(res)
                })
            })
            Promise.all(newArr).then(() => {
                if (this.approval_id) {
                    this.btnDisabled = true
                    editApprovalFormInfo({
                        approval_id: this.approval_id,
                        form_data: this.purchaseForm,
                    }).then(res => {
                        if (res.code === 200) {
                            this.$toast.success('修改成功')
                            this.$emit('refresh')
                            this.handleDialogClose()
                        }
                    })
                    return false
                }
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
                purchaseAdd({
                    order_id: this.order_id,
                    order_num: this.order_detail.order_num,
                    customer_name: this.order_detail.customer_id?.text,
                    ...this.purchaseForm,
                    order_updated_at: this.order_detail.updated_at,
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('新增成功')
                        this.$emit('refresh')
                        this.$emit('update:order_purchase_id', 0)
                        this.handleDialogClose()
                    }
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.goods_details_content {
    padding: 8px !important;
}

.order_price_change_list {
    margin-bottom: 0;

    .order_price_change_item {
        .field_name {
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.purchase_details_item_content {
    .van-cell {
        padding: 10px 0;

        &.van-cell--required {
            padding: 10px 6px;

            &::before {
                left: 0;
            }
        }
    }
}
</style>